import Swiper from 'swiper/bundle';

const swiper = new Swiper('.reference-wrap .swiper', {
	effect: 'slide',
	speed: 600,
	direction: 'horizontal',
	loop: true,
	slidesPerView: 1,
	autoplay: {
		delay: 10000,
	},

	pagination: {
		el: '.swiper__pagination',
		clickable: true,
		bulletClass: 'swiper__bullet',
		bulletActiveClass: 'swiper__bullet--active',
		renderBullet: function (index, className) {
			return '<span class="' + className + '"></span>';
		},
	},
});
